import React from "react"
import PropTypes from "prop-types"
import { css } from "react-emotion/macro"
import { Wrapper } from "./style"
import { slugify } from "../../utils"
import { ArrowRight } from "../Icons/ArrowRight"
import { ArrowLeft } from "../Icons/ArrowLeft"
import { Transition } from "react-spring"

const timeline = [
  {
    year: 1950,
    content:
      "The Center becomes the Church of Truth and moves to 3rd & Bell Street.",
  },
  {
    year: 1960,
    content:
      "The Church of Truth becomes the Christ Church of Religious Science. Under the guidance of Senior Minister, Louis Malone – who presided from 1960 to 1973. The Church moves to 26th Ave. NW in Ballard in 1962.",
  },
  {
    year: 1973,
    content:
      "The Church undergoes another name change, becoming Seattle Church of Religious Science, followed by a 1982 move to Northgate Mall. From 1973 to 1975, Senior Minister, Glen Wood presides.",
  },
  {
    year: 1975,
    content: "A new Senior Minister Jim Munson, presides until 1988.",
  },
  {
    year: 1988,
    content:
      "Senior Minister, Kathianne Lewis, DD is chosen to replace Jim Munson.",
  },
  {
    year: 1992,
    content:
      "The Seattle Church of Religious Science moves to Sand Point Way NE.",
  },
  {
    year: 1994,
    content:
      "The name is changed again, becoming the Center for Spiritual Living.",
  },
  {
    year: 2008,
    content: "Celebration Hall is built.",
  },
  {
    year: 2018,
    content:
      "Center for Spiritual Living moves to its interim home at the Mountaineers located in Magnusson Park and purchases it's new home in Greenlake.",
  },
]

export class CSLTimeline extends React.Component {
  state = {
    showLeftArrow: false,
    showRightArrow: true,
  }
  scrollContainerRef = React.createRef()
  componentDidMount() {
    if (this.scrollContainerRef.current) {
      this.scrollContainerRef.current.addEventListener(
        "scroll",
        this.handleScroll,
      )
    }
  }
  componentWillUnmount() {
    if (this.scrollContainerRef.current) {
      this.scrollContainerRef.current.removeEventListener(
        "scroll",
        this.handleScroll,
      )
    }
  }
  handleScroll = (event) => {
    const scrollEndHit =
      event.currentTarget.scrollWidth -
        window.outerWidth +
        (window.outerWidth - event.currentTarget.offsetWidth) ===
      event.currentTarget.scrollLeft

    if (event.currentTarget.scrollLeft > 0 && !this.state.showLeftArrow)
      this.setState({ showLeftArrow: true })

    if (event.currentTarget.scrollLeft === 0 && this.state.showLeftArrow)
      this.setState({ showLeftArrow: false })

    if (scrollEndHit && this.state.showRightArrow)
      this.setState({ showRightArrow: false })

    if (!scrollEndHit && !this.state.showRightArrow)
      this.setState({ showRightArrow: true })
  }
  render() {
    return (
      <Wrapper
        {...{
          className: css`
            padding-left: 25px;
            padding-right: 25px;
            position: relative;

            @media (min-width: 1220px) {
              padding-left: 0;
              padding-right: 0;

              .arrows {
                display: none;
              }
            }
          `,
          style: this.props.style,
          columnSpace: this.props.columnSpace,
          breakpoint: this.props.breakpoint,
          rowSpace: this.props.rowSpace,
          id: slugify(this.props.title) || "",
        }}
      >
        <div
          ref={this.scrollContainerRef}
          className={css`
            overflow-x: scroll;

            .bar-container {
              height: 538px;
              width: 1163px;
              margin-left: auto;
              margin-right: auto;
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .bar {
              display: flex;
              background: #717070;
              color: #424345;
            }

            .point {
              font-weight: normal;
              line-height: normal;
              font-size: 24px;
              padding: 0 37.5px 5px;
              position: relative;

              &:first-of-type,
              &:last-of-type {
                .content {
                  width: 130px;
                }
              }
            }

            .content {
              position: absolute;
              background-color: #fff;
              line-height: 19px;
              font-size: 13px;
              text-align: center;
              width: 168px;
              left: 50%;

              &::before,
              &::after {
                background: #ed9150;
                position: absolute;
                left: 0;
                right: 0;
                margin: auto;
                content: "";
              }

              &::before {
                height: 3px;
                width: 80%;
              }

              &::after {
                width: 3px;
                height: 55px;
              }

              &.position-top {
                top: -65px;
                transform: translateY(-100%) translateX(-50%);

                &::before {
                  top: calc(100% + 8px);
                }

                &::after {
                  top: calc(100% + 10px);
                }
              }

              &.position-bottom {
                top: calc(100% + 65px);
                transform: translateX(-50%);

                &::before {
                  top: -11px;
                }

                &::after {
                  top: -65px;
                }
              }
            }
          `}
        >
          <div className="bar-container">
            <div className={"bar"}>
              {timeline.map((point, i) => (
                <div className="point" key={point.year}>
                  <span className="year">{point.year}</span>
                  <div
                    className={`content position-${
                      i % 2 === 0 ? "top" : "bottom"
                    }`}
                  >
                    {point.content}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          className={css`
            .arrows {
              position: absolute;
              top: 0;
              bottom: 0;
              display: flex;
              align-items: center;

              &.left {
                left: 5px;
              }

              &.right {
                right: 5px;
              }
            }
          `}
        >
          <React.Fragment>
            <Transition
              from={{ opacity: 0 }}
              enter={{ opacity: 1 }}
              leave={{ opacity: 0 }}
            >
              {this.state.showLeftArrow &&
                ((styles) => (
                  <div className="arrows left" style={styles}>
                    <ArrowLeft />
                  </div>
                ))}
            </Transition>
            <Transition
              from={{ opacity: 0 }}
              enter={{ opacity: 1 }}
              leave={{ opacity: 0 }}
            >
              {this.state.showRightArrow &&
                ((styles) => (
                  <div className="arrows right" style={styles}>
                    <ArrowRight />
                  </div>
                ))}
            </Transition>
          </React.Fragment>
        </div>
      </Wrapper>
    )
  }
}

CSLTimeline.propTypes = {
  /** Vertical spacing base */
  rowSpace: PropTypes.number,
  /** Horizontal spacing base */
  columnSpace: PropTypes.number,
  /** Mobile first breakpoint */
  breakpoint: PropTypes.number,
  className: PropTypes.string,
  /** Secondary className. With WP/ACF, comes from the admin when content is created  */
  adminclass: PropTypes.string,
  style: PropTypes.object,
}

CSLTimeline.defaultProps = {
  className: "",
  adminclass: "",
  style: {},
  rowSpace: 60,
  columnSpace: 30,
  breakpoint: 992,
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/FlexibleContent/CSLTimeline.js